
import { Component, Vue } from "vue-property-decorator";
import ContainerFrame from "@/components/ContainerFrame.vue";
import Managers from "@/components/operator/Managers.vue";
import OperatorContactDataForm from "@/components/operator/OperatorContactDataForm.vue";
import OperatorPlatformService from "@/components/operator/OperatorPlatformService.vue";
import ReminderMailSettings from "@/components/operator/ReminderMailSettings.vue";
import BlockAndDeleteOperator from "@/components/operator/BlockAndDeleteOperator.vue";
import Documents from "@/components/operator/Documents.vue";
import Chipcards from "@/components/operator/Chipcards.vue";
import Owners from "@/components/operator/Owners.vue";
import EmailTemplates from "@/components/operator/EmailTemplates.vue";
import { EmailTemplate } from "@/api/dtos/EmailTemplate.schema";
import { Operator } from "@/api/dtos/Operator.schema";
import { OperatorsModule } from "@/store/modules/OperatorsModule";
import OperatorFinanceDataForm from "@/components/operator/OperatorFinanceDataForm.vue";
import SectionNav, { Section } from "@/components/SectionNav.vue";
import { User } from "@/api/dtos/User.schema";
import { UsersModule } from "@/store/modules/UsersModule";
@Component({
  components: {
    ContainerFrame,
    Managers,
    OperatorContactDataForm,
    OperatorPlatformService,
    ReminderMailSettings,
    BlockAndDeleteOperator,
    Documents,
    Chipcards,
    Owners,
    EmailTemplates,
    OperatorFinanceDataForm,
    SectionNav,
  },
})
export default class OperatorView extends Vue {
  get operator(): Operator | null {
    const op = OperatorsModule.detailedOperator;
    // Only expose the operator to the template if it matches the current route id
    return op && op.uuid === this.operatorId ? op : null;
  }

  get operatorId(): string {
    return this.$route.params.operatorUuid;
  }

  get localUser(): User | null {
    return UsersModule.localUser;
  }

  get isAdmin(): boolean {
    return this.localUser == null ? false : this.localUser.isAdmin;
  }

  mounted(): void {
    if (this.operatorId) {
      OperatorsModule.fetchOperator(this.operatorId);
    } else {
      this.$router.push({ name: "Stationen" });
    }
  }

  sectionList: Section[] = [
    {
      id: "contact-data",
      label: "Kontaktdaten",
    },
    {
      id: "finance-data",
      label: "Finanzdaten",
    },
    {
      id: "owners",
      label: "Eigentümer",
    },
    {
      id: "station-manager",
      label: "Stations-Manager",
    },
    {
      id: "chip",
      label: "RFID-Transponder",
    },
    {
      id: "email",
      label: "Email-Vorlagen",
    },
    {
      id: "reminder",
      label: "Erinnerungsemail",
    },
    {
      id: "document",
      label: "Dokumente",
    },
  ];
}
